'use client';

import { PropsWithChildren } from 'react';

export interface ILinkCodeProps extends PropsWithChildren {
  code: string;
}

export const LinkCode = ({ code, children }: ILinkCodeProps) => (
  <a
    href="#"
    onClick={(event) => {
      event.preventDefault();
      new Function(code)();
    }}
  >
    {children}
  </a>
);
